import _extends from "@babel/runtime/helpers/extends";
/** @jsxRuntime classic */
/** @jsx h */
import { getRelatedProducts } from '@algolia/recommend-core';
import { createRelatedProductsComponent } from '@algolia/recommend-vdom';
import { html } from 'htm/preact';
import { createElement, Fragment, h, render } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { getHTMLElement } from './getHTMLElement';
import { useAlgoliaAgent } from './useAlgoliaAgent';
import { useStatus } from './useStatus';
import { withHtml } from './utils';
const UncontrolledRelatedProducts = createRelatedProductsComponent({
  createElement,
  Fragment
});
function useRelatedProducts(props) {
  const [result, setResult] = useState({
    recommendations: []
  });
  const {
    status,
    setStatus
  } = useStatus('loading');
  useAlgoliaAgent({
    recommendClient: props.recommendClient
  });
  useEffect(() => {
    setStatus('loading');
    getRelatedProducts(props).then(response => {
      setResult(response);
      setStatus('idle');
    });
  }, [props, setStatus]);
  return {
    ...result,
    status
  };
}
function RelatedProducts(props) {
  const {
    recommendations,
    status
  } = useRelatedProducts(props);
  return h(UncontrolledRelatedProducts, _extends({}, props, {
    items: recommendations,
    status: status
  }));
}
export function relatedProducts({
  container,
  environment = window,
  itemComponent,
  fallbackComponent,
  headerComponent,
  view,
  children,
  ...props
}) {
  const vnode = h(RelatedProducts, _extends({}, props, {
    view: view && withHtml(view),
    itemComponent: itemComponent && withHtml(itemComponent),
    headerComponent: headerComponent && withHtml(headerComponent),
    fallbackComponent: fallbackComponent && withHtml(fallbackComponent)
  }), children ? childrenProps => children({
    ...childrenProps,
    html
  }) : undefined);
  if (!container) {
    return vnode;
  }
  render(vnode, getHTMLElement(container, environment));
  return null;
}